import { getMe } from "@/services/user";
import { User } from "@/shared/types/user";

import { useUserStore } from "@/store/useUser";
import { useMutation } from "@tanstack/react-query";

import { AxiosError } from "axios";
import { useSignOut } from "./useAuth";
import { showToast } from "@/shared/utils/toast";

export function useGetMe() {
  const { setUser } = useUserStore();
  const { mutate: signOut } = useSignOut();

  return useMutation<User, AxiosError>({
    mutationKey: ["useGetMe"],
    mutationFn: getMe,
    onSuccess: (res) => {
      setUser(res);
    },
    onError: () => {
      showToast.error({
        title: "Something went wrong.",
        description: "Please sign in again.",
      });
      signOut();
    },
  });
}

// export function useRefreshToken() {
//   const { setAccessToken } = useAuthStore();
//   const navigate = useNavigate();
//   return useMutation<SignInResponse, AxiosError>({
//     mutationKey: ["useRefreshToken"],
//     mutationFn: refreshToken,
//     onSuccess: (res) => {
//       if (!res) return;
//       setAccessToken(res.accessToken);
//     },
//     onError: () => {
//       showToast.error({
//         title: "Session expired.",
//         description: "Please sign in again.",
//       });
//       clearAllStores();
//       navigate({ to: "/sign-in", replace: true });
//     },
//   });
// }
